import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import {
  CONTRACTOR_QUESTIONNARE,
  QUESTIONNARE_ROOOT,
  RESTURANT_QUESTIONNARE,
} from "./Business.constants";

const QuestionnareRoot = Loadable(
  lazy(() =>
    import("./QuestionnareRoot").then(({ QuestionnareRoot }) => ({
      default: QuestionnareRoot,
    }))
  )
);
const ResturantQuestionare = Loadable(
  lazy(() =>
    import("./ResturantQuestionare/ResturantQuestionare").then(
      ({ ResturantQuestionare }) => ({
        default: ResturantQuestionare,
      })
    )
  )
);
const ContractorQuestionare = Loadable(
  lazy(() =>
    import("./Contractor/ContractorQuestionare").then(
      ({ ContractorQuestionare }) => ({
        default: ContractorQuestionare,
      })
    )
  )
);
export const QuestionnareRoutes = [
  {
    path: `${QUESTIONNARE_ROOOT}/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <QuestionnareRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${QUESTIONNARE_ROOOT}/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <QuestionnareRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${RESTURANT_QUESTIONNARE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ResturantQuestionare />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${RESTURANT_QUESTIONNARE}/:resturantNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ResturantQuestionare />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CONTRACTOR_QUESTIONNARE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ContractorQuestionare />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CONTRACTOR_QUESTIONNARE}/:contractorNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ContractorQuestionare />
      </AuthorizedRoute>
    ),
  },
];
